/* eslint-disable max-len */
/* eslint-disable react/function-component-definition */
import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="grid items-start gap-y-8 flex-1 mx-16 my-12 text-sm/normal text-left font-sans tracking-normal">
      <h1 className="text-3xl font-bold text-center">
        Политика обработки персональных данных
      </h1>
      <div className="flex flex-col gap-6">
        <h3
          className="text-2xl font-semibold"
          id="anchor-0"
        >
          1. Общие положения
        </h3>
        <p>
          1.1.Настоящая Политика обработки персональных данных (далее — Политика) является основополагающим документом ООО «А2СОФТ» (далее — Оператор, ИНН 1657249187, ОГРН 1181690082067), определяющим основные права и обязанности
          Оператора и субъекта персональных данных, категории субъектов персональных данных, объем и категории обрабатываемых
          персональных данных, порядок и условия их обработки Оператором, а также меры по обеспечению их безопасности.
          <br />
          1.2. Политика разработана и применяется в соответствии с п. 2 ч. 1 ст. 18.1. Федерального закона от 27.07.2006
          №152-ФЗ «О персональных данных» (далее — ФЗ «О персональных данных») и подлежит доведению до всеобщего сведения
          посредством опубликования на официальном сайте Оператора.
          <br />
          1.3. Политика является основой для организации обработки персональных данных Оператором, в том числе для разработки
          внутренней документации Оператора, регулирующей обработку персональных данных.
          <br />
          1.4. Термины и определения, используемые в Политике, употребляются в значении, определенном в ФЗ «О персональных
          данных».
          <br />
          1.5. Оператор осуществляет обработку персональных данных с использованием баз данных, находящихся на территории
          Российской Федерации, за исключением случаев, когда иное допускается ФЗ «О персональных данных».
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-1"
        >
          2. Принципы обработки персональных данных
        </h3>
        <p>
          2.1. Оператор осуществляет обработку персональных данных, исходя из следующих принципов:
          {' '}
          <br />
          2.1.1. законность целей и способов обработки персональных данных;
          {' '}
          <br />
          2.1.2. ограничение обработки персональных данных достижением конкретных, заранее определенных и законных целей;
          {' '}
          <br />
          2.1.3. соответствие содержания и объема персональных данных заявленной цели обработки без их избыточности;
          {' '}
          <br />
          2.1.4. недопустимость объединения баз данных, содержащих персональные данные, обрабатываемые для целей несовместимых
          между собой;
          {' '}
          <br />
          2.1.5. точность, достаточность персональных данных, а в необходимых случаях — актуальность по отношению к целям
          обработки персональных данных. Оператор принимает необходимые меры по удалению или уточнению неполных или неточных
          данных;
          {' '}
          <br />
          2.1.6. хранение персональных данных должно осуществляться в форме, позволяющей определить субъекта персональных
          данных, в течение срока не больше, чем этого требуют цели обработки персональных данных, если срок хранения
          персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или
          поручителем по которому является субъект персональных данных;
          {' '}
          <br />
          2.1.7. уничтожение персональных данных по достижению цели их обработки, или в случае утраты необходимости в
          достижении этих целей, если иное не предусмотрено законодательством Российской Федерации;
          {' '}
          <br />
          2.1.8. обеспечение конфиденциальности и безопасности персональных данных.
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-2"
        >
          3. Основания обработки персональных данных
        </h3>
        <p>
          3.1. Обработка персональных данных Оператором производится при наличии хотя бы одного основания и может продолжаться
          до момента, пока не прекратят действие все основания обработки.
          {' '}
          <br />
          3.2. Обработка персональных данных производится в следующих случаях:
          {' '}
          <br />
          3.2.1. с согласия субъекта персональных данных на обработку его персональных данных;
          {' '}
          <br />
          3.2.2. для достижения целей, предусмотренных международным договором Российской Федерации или законом, для
          осуществления и выполнения возложенных законодательством Российской Федерации на оператора функций, полномочий и
          обязанностей;
          {' '}
          <br />
          3.2.3. для исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в
          соответствии с законодательством Российской Федерации об исполнительном производстве;
          {' '}
          <br />
          3.2.4. в связи с участием лица в конституционном, гражданском, административном, уголовном судопроизводстве,
          судопроизводстве в арбитражных судах;
          {' '}
          <br />
          3.2.5. для исполнения договора, стороной которого, либо выгодоприобретателем или поручителем по которому является
          субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или
          договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем;
          {' '}
          <br />
          3.2.6. для защиты жизни, здоровья или иных жизненно важных интересов субъекта персональных данных, если получение
          согласия субъекта персональных данных невозможно;
          {' '}
          <br />
          3.2.7. для осуществления прав и законных интересов оператора или третьих лиц при условии, что при этом не нарушаются
          права и свободы субъекта персональных данных;
          {' '}
          <br />
          3.2.8. для осуществления прав и законных интересов оператора или третьих лиц, в том числе в случаях, предусмотренных
          Федеральным законом &quot;О защите прав и законных интересов физических лиц при осуществлении деятельности по возврату
          просроченной задолженности и о внесении изменений в Федеральный закон &quot;О микрофинансовой деятельности и
          микрофинансовых организациях&quot;, либо для достижения общественно значимых целей при условии, что при этом не
          нарушаются права и свободы субъекта персональных данных;
          {' '}
          <br />
          3.2.9. при необходимости обработки персональных данных, подлежащих опубликованию или обязательному раскрытию в
          соответствии с федеральным законом.
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-3"
        >
          4. Цели обработки персональных данных
        </h3>
        <p>
          4.1. Осуществление прав и законных интересов Оператора как разработчика и правообладателя программного обеспечения в
          рамках ведения предпринимательской деятельности в области информационных технологий, предоставления прав
          использования программного обеспечения, предоставления сервисов технической поддержки программного обеспечения при:
        </p>
        <p>
          4.1.1. заключении и исполнении гражданско-правовых договоров с контрагентами-юридическими лицами:
          {' '}
          <br />
          · которым Оператор предоставляет права использования программного обеспечения, сервисы технической поддержки
          программного обеспечения, оказывает информационно-консультационные услуги, в том числе по проведению тренингов,
          практикумов, сертификации их работников (лицензиаты, партнеры, заказчики и др.);
          {' '}
          <br />
          · у которых Оператор приобретает товары, работы, услуги для ведения своей основной предпринимательской деятельности
          и хозяйственной деятельности (поставщики, подрядчики, исполнители и др.);
          {' '}
          <br />
          4.1.2. заключении и исполнении гражданско-правовых договоров с контрагентами-физическими лицами (в том числе
          индивидуальными предпринимателями), стороной или выгодоприобретателем по которому является субъект персональных
          данных;
          {' '}
          <br />
          4.1.3. участии в тендерах (аукционах и конкурсах, а также в иных процедурах, предусмотренных действующим
          законодательством) и подготовке необходимых для участия в тендерах документов;
          {' '}
          <br />
          4.1.4. поиске, анализе и определении потенциально заинтересованных в сотрудничестве лиц, осуществлении
          организационного взаимодействия с потенциальными контрагентами на сайте Оператора, лидогенерации, установлении и
          поддержании устойчивого делового общения с заинтересованными лицами, маркетинговых мероприятиях для заинтересованных
          в сотрудничестве лиц, осуществлении преддоговорного взаимодействия; аналитика данных по сайту Оператора с помощью
          Яндекс.Метрика.
          {' '}
          <br />
          4.2. Осуществление прав и законных интересов Оператора как работодателя в рамках:
          {' '}
          <br />
          4.2.1. управления персоналом, организации, обеспечения и регулирования трудовых отношений и кадрового учета, в том
          числе для предоставления доступа к функционалу сервиса кадрового электронного документооборота «HR link» и его
          применения Оператором, содействия в трудоустройстве, получения образования, организации мероприятий по обучению, в
          том числе с помощью обучающих платформ, развитию, оценке персонала, оценки эффективности и результатов работ,
          продвижения по службе, контроля качества выполняемой работы, обеспечения сохранности имущества, в том числе для
          обеспечения работников программными и аппаратными средствами, информационными системами, сервисами, доступами для
          выполнения трудовых функций;
          {' '}
          <br />
          4.2.2. поддержки и мотивации персонала, предоставления корпоративных бонусов и привилегий, гарантий, в том числе
          добровольного медицинского страхования, вручения подарков, адаптации и онбординга специалистов, выстраивания и
          укрепления внутренних коммуникаций, размещения информации о работнике на внутренних информационно-справочных
          ресурсах Оператора, организации служебных поездок, командировок, организации корпоративных мероприятий;
          {' '}
          <br />
          4.2.3. подбора персонала, сопровождения процессов, связанных с отбором кандидатов на замещение вакантных должностей,
          проверки достоверности сведений о кандидатах и их благонадежности, создания кадрового резерва;
          {' '}
          <br />
          4.2.4. обеспечения прохождения ознакомительной, производственной или преддипломной практики на основании договора с
          учебным заведением.
          {' '}
          <br />
          4.3. Соблюдение и исполнение требований действующего законодательства Российской Федерации и иных
          нормативно-правовых актов Российской Федерации, локальных нормативных актов и других внутренних документов
          Оператора, включая, но не ограничиваясь, для:
          {' '}
          <br />
          4.3.1. обеспечения безопасности и организации пропускного режима на территории офиса Оператора, принятия мер должной
          осмотрительности в отношении потенциальных и действующих контрагентов и проверки достоверности сведений о
          кандидатах, включая управление юридическими, налоговыми, финансовыми, операционными, репутационными и комплаенс
          рисками;
          {' '}
          <br />
          4.3.2. расчета и выплаты заработной платы/иного вознаграждения работникам Оператора и подачи сведений в рамках
          зарплатного проекта; расчета и выплаты вознаграждений физическим лицам по договорам гражданско-правового характера;
          ведения бухгалтерского и налогового учета, ведения воинского учета, уплаты налогов, передачи персональных данных в
          Фонд пенсионного и социального страхования Российской Федерации, Федеральную налоговую службу, иные органы власти;
          {' '}
          <br />
          4.3.3. проведения собраний участников Оператора, других корпоративных процедур;
          {' '}
          <br />
          4.3.4. рассмотрения жалоб, претензий, урегулирования споров, участия в судопроизводстве; исполнения запросов
          уполномоченных государственных органов или должностных лиц и субъектов персональных данных; исполнения судебных
          актов, актов других органов или должностных лиц, подлежащих исполнению в соответствии с законодательством РФ.
          <br />
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-4"
        >
          5. Субъекты персональных данных и категории обрабатываемых персональных данных
        </h3>
        <p>
          5.1. Оператор обрабатывает персональные данные следующих категорий субъектов в следующем объеме:
          {' '}
          <br />
          5.1.1. для достижения цели, указанной в п.4.1.1. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - представители и работники контрагентов-юридических лиц;
          {' '}
          <br />
          - участники и бенефициары Оператора;
          {' '}
          <br />
          - работники Оператора.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, адрес электронной почты, номер телефона; сведения о месте работы (наименование
          контрагента-юридического лица) и занимаемой должности; реквизиты и сведения документа, удостоверяющего личность;
          дата рождения, место рождения, гражданство; место проживания/регистрации; сведения, указанные в доверенности;
          сведения, указанные в списке участников Общества/выписке из реестра акционеров/справке о цепочке бенефициарных
          собственников; сведения о доступах в системы и учетные данные для доступа; сведения, которые могут содержать
          персональные данные, содержащиеся в обращении в службу технической поддержки Оператора.
          {' '}
          <br />
          5.1.2. для достижения цели, указанной в п.4.1.2. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - физические лица (в том числе индивидуальные предприниматели);
          {' '}
          <br />
          - работники Оператора.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, адрес электронной почты, номер телефона; ОГРНИП, ИНН, СНИЛС; реквизиты и сведения
          документа, удостоверяющего личность; дата рождения, место рождения, гражданство; место проживания/регистрации;
          реквизиты расчетного счета, название обслуживающего банка; сведения о применяемом налоговом режиме, сведения об
          оформлении статуса плательщика налога на профессиональный доход, сведения о налоговом статусе (резидент/нерезидент);
          при необходимости: реквизиты и сведения миграционной карты, документа, разрешающего работу в РФ, если он требуется
          (патент, рабочая виза и разрешение на работу, разрешение на временное проживание, вид на жительство); должность.
          {' '}
          <br />
          5.1.3. для достижения цели, указанной в п.4.1.3. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - представители и работники контрагентов-юридических лиц;
          {' '}
          <br />
          - участники и бенефициары Оператора;
          {' '}
          <br />
          - работники Оператора.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, адрес электронной почты, номер телефона; сведения о месте работы (наименование
          контрагента-юридического лица) и занимаемой должности; реквизиты и сведения документа, удостоверяющего личность;
          дата рождения, место рождения, гражданство; место проживания/регистрации; сведения, указанные в доверенности;
          сведения, указанные в списке участников Общества/выписке из реестра акционеров/справке о цепочке бенефициарных
          собственников; аффилированность/взаимозависимость, основание (основания), в силу которого лицо признается
          аффилированным/взаимозависимым; сведения о трудовой деятельности: реквизиты трудового договора, сведения из
          трудового договора, копия трудовой книжки; сведения об участии в проектах Оператора и других компаний, о
          самостоятельных проектах; сведения об образовании (включая сведения об ученой степени и/или ученом звании).
          {' '}
          <br />
          5.1.4. для достижения цели, указанной в п.4.1.4. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - посетители сайта Оператора;
          {' '}
          <br />
          - представители потенциальных контрагентов.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя отчество, адрес электронной почты, номер телефона, наименование компании, должность; сведения о
          количестве визитов, просмотров, посетителей, в том числе новых, просматриваемые пользователем часть/раздел сайта;
          вебвизор: пользовательский путь; время на сайте; глубина просмотра; тип устройства; возрастной сегмент пользователя;
          тип браузера; откуда совершен переход: мессенджер, соцсеть; пол; UserID, ClientID, страна, язык;
          cookie:_ym_metrika_enabled, _ym_isad,_ym_uid,_ym_d, gdpr, is_gdpr, is_gdpr_b; localStorage:_ym&lt;номер
          счетчика&gt;_lastHit;_ym&lt;номер счетчика&gt;_lsid; _ym&lt;номер счетчика&gt;_reqNum, _ym_retryReqs, zz.
          {' '}
          <br />
          5.1.5. для достижения цели, указанной в п.4.2.1. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - работники Оператора.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          фамилия, имя, отчество, в том числе латинскими буквами (предыдущие фамилии, имена и (или) отчества, в случае их
          изменения); гражданство; пол; возраст, дата рождения; место рождения; реквизиты и сведения документа,
          удостоверяющего личность и реквизиты выданных ранее документов, удостоверяющих личность; адрес места жительства
          (адрес регистрации, фактического проживания); СНИЛС, ИНН; сведения о налоговом статусе (резидент/нерезидент);
          сведения о социальных и иных льготах (наименование льготы, номер и дата выдачи документа); номер телефона (домашний,
          мобильный); адреса электронной почты (личная, рабочая); степень родства, семейное положение; должность, структурное
          подразделение; сведения об образовании: уровне образования, наименовании организации, осуществляющей образовательную
          деятельность, о дополнительном профессиональном образовании (при наличии), квалификации, сертификации,
          профессиональной подготовке и переподготовке, о повышении квалификации, наименования и годы окончания каждого
          обучения, период обучения, наименования и реквизиты документов об образовании или документов, подтверждающих
          прохождение обучения, специальность (-ти), сведения об ученой степени; информация о владении иностранными языками,
          степень владения; статус военнообязанного и сведения и реквизиты документов воинского учета; сведения о трудовой
          деятельности(в том числе выполненных или выполняемых проектах), профессии, трудовом стаже, предыдущих местах работы,
          структурных подразделениях, сведения о кадровых мероприятиях и их датах (в частности: приеме на работу/увольнения,
          переводов на другую работу), сведения о номере, серии и дате выдачи трудовой книжки; сведения о прохождении
          государственной гражданской службы; сведения о состоянии здоровья, которые относятся к вопросу о возможности
          выполнения работником трудовой функции (категория годности, инвалидность, временная нетрудоспособность) и реквизиты
          подтверждающих документов; фотография; номер расчетного счета и банковской карты (банковские реквизиты); сведения о
          достижениях, наградах, поощрениях; сведения о предпринимательской деятельности и участии в деятельности организаций;
          сведения о хобби, интересах; при необходимости: реквизиты и сведения миграционной карты, документа, разрешающего
          работу в РФ, если он требуется (патент, рабочая виза и разрешение на работу, разрешение на временное проживание, вид
          на жительство); данные выдаваемого оборудования: артикул, серийный номер, стоимость, наименование, дата выдачи, дата
          покупки, тип устройства, местонахождение оборудования; идентификатор.
          {' '}
          <br />
          5.1.6. для достижения цели, указанной в п.4.2.2. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - работники Оператора;
          {' '}
          <br />
          - родственники работников Оператора (супруг/супруга, близкие родственники)
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество; пол; возраст, дата рождения, место рождения; гражданство; степень родства, семейное
          положение; адрес места жительства (адрес регистрации, фактического проживания); адрес электронной почты, номер
          телефона; сведения о месте работы, должность, структурное подразделение; реквизиты и сведения документа,
          удостоверяющего личность; реквизиты и сведения загранпаспорта и срок его действия (при необходимости); СНИЛС, ИНН;
          фотография, сведения об успехах работника (участие в мероприятиях, получение свидетельств и сертификатов об
          обучении, уровень квалификации, успешный опыт взаимодействия с заказчиками, персональные показатели эффективности),
          сведения о трудовой деятельности (в том числе выполненных или выполняемых проектах), профессии, трудовом стаже,
          предыдущих местах работы, структурных подразделениях, сведения о кадровых мероприятиях и их датах (в частности:
          приеме на работу/увольнения, переводов на другую работу); реквизиты и сведения документов об обучении; сведения о
          хобби, интересах; номер бонусной карты туроператора/перевозчика (при наличии); реквизиты и сведения документов о
          размещении (временном проживании) и проездных документах.
          {' '}
          <br />
          5.1.7. для достижения цели, указанной в п.4.2.3. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - кандидаты;
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество; пол; возраст, дата рождения, место рождения; гражданство; адрес электронной почты/ник в
          мессенджерах; номер телефона; город, в котором идет поиск работы; сведения об образовании: уровень образования, в
          том числе послевузовское профессиональное образование; тренинги; курсы; наименование и год окончания
          образовательного учреждения, период обучения, наименование и реквизиты документа об образовании, специальность по
          документу об образовании, квалификация или квалификационный уровень, прохождение сертификации, ее результаты;
          сведения об ученой степени; сведения о трудовой деятельности: общий срок опыта работы, прошлые места работы, период
          работы на каждом месте, рекомендательное письмо (при наличии); ключевые навыки; реквизиты и сведения документа,
          удостоверяющего личность; адрес места жительства (адрес регистрации, фактического проживания); ИНН; СНИЛС; сведения
          о налоговом статусе (резидент/нерезидент); сведения о предпринимательской деятельности и участии в деятельности
          организаций; степень родства, семейное положение; статус военнообязанного и сведения и реквизиты документов
          воинского учета; сведения об увлечениях, хобби, интересах; при необходимости: сведения о виде на постоянное
          жительство или разрешении на работу.
          {' '}
          <br />
          5.1.8. для достижения цели, указанной в п.4.2.4. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - учащиеся, студенты, представители образовательных учреждений.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, дата рождения, место рождения, адрес электронной почты, номер телефона, адрес места
          жительства (адрес регистрации, фактического проживания); гражданство; сведения об образовании.
          {' '}
          <br />
          5.1.9. для достижения цели, указанной в п.4.3.1. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - потенциальные контрагенты: представители юридических лиц и их бенефициары,
          {' '}
          <br />
          - потенциальные контрагенты: физические лица, в том числе индивидуальные предприниматели (сторона или
          выгодоприобретатель по гражданско-правовому договору);
          {' '}
          <br />
          - работники Оператора и их близкие родственники работников, супруг/супруга, соискатели, бывшие работники.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, адрес электронной почты, номер телефона; сведения о месте работы (наименование
          контрагента-юридического лица) и занимаемой должности; реквизиты и сведения документа, удостоверяющего личность;
          дата рождения, место рождения, гражданство; место проживания/регистрации; сведения, указанные в доверенности;
          сведения, указанные в списке участников Общества/выписке из реестра акционеров/справке о цепочке бенефициарных
          собственников; аффилированность/взаимозависимость, основание (основания), в силу которого лицо признается
          аффилированным; ОГРНИП, ИНН, СНИЛС; сведения о налоговом режиме, сведения о налоговом статусе (резидент/нерезидент);
          сведения о применении специальных режимов налогообложения, реквизиты подтверждающих документов; сведения об
          оформлении статуса плательщика налога на профессиональный доход; при необходимости: реквизиты и сведения
          миграционной карты, документа, разрешающего работу в РФ, если он требуется (патент, рабочая виза и разрешение на
          работу, разрешение на временное проживание, вид на жительство); степень родства, семейное положение; сведения,
          подтверждающие полномочия исполнительного органа контрагента; сведения о ресурсах, которыми располагает контрагент
          для выполнения обязательств по договору.
          {' '}
          <br />
          5.1.10. для достижения цели, указанной в п.4.3.2. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - работники Оператора и их близкие родственники работников, супруг/супруга, кандидаты, бывшие работники;
          {' '}
          <br />
          - физические лица (в том числе индивидуальные предприниматели).
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          фамилия, имя, отчество, в том числе предыдущие фамилии, имена и (или) отчества (в случае их изменения); пол;
          возраст, дата рождения; место рождения; реквизиты и сведения документа, удостоверяющего личность; адрес места
          жительства (адрес регистрации, фактического проживания); гражданство; СНИЛС, ИНН; сведения о налоговом статусе
          (резидент/нерезидент); сведения о социальных и иных льготах (наименование льготы, номер и дата выдачи документа);
          номер телефона (домашний, мобильный); адреса электронной почты (личная, рабочая); сведения о трудовой деятельности,
          профессии, трудовом стаже, предыдущих местах работы, сведения о кадровых мероприятиях и их правовые основания
          (приеме на работу/увольнения, переводов на другую работу), сведения о номере, серии и дате выдачи трудовой книжки;
          профессия, должность, специальность, квалификация, квалификационный уровень, конкретный вид поручаемой работы,
          структурное подразделение; Номер расчетного счета и банковской карты (банковские реквизиты); оклад, надбавка, данные
          о начисленных суммах (заработной платы и иных), сведения о стандартных, социальных и налоговых вычетах, суммы
          налогов исчисленных и (не-)удержанных, страховые взносы; семейное положение, состав семьи и сведения о близких
          родственниках (в том числе бывших), сведения об опекунах и попечителях, сведения и реквизиты свидетельств,
          подтверждающих родство, усыновление, опекунство; сведения, необходимые для предоставления социальных и имущественных
          налоговых вычетов, в частности, согласно п. п. 2-5 и п.п. 7 п.1 ст. 219 НК РФ и пп. 3 и 4 п.1 ст. 220 НК РФ;
          реквизиты и сведения договора с физическим лицом; сведения об обучении и форме обучения в образовательном
          учреждении, а также реквизиты документа, подтверждающего обучение; сведения о работе в районах Крайнего
          севера/работе в местностях, приравненных к районам Крайнего севера; при необходимости: реквизиты и сведения
          миграционной карты, документа, разрешающего работу в РФ, если он требуется (патент, рабочая виза и разрешение на
          работу, разрешение на временное проживание, вид на жительство); статус беженца.
          {' '}
          <br />
          5.1.11. для достижения цели, указанной в п.4.3.3. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - участники и бенефициары Оператора
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, дата рождения; место рождения; реквизиты и сведения документа, удостоверяющего личность;
          адрес места жительства (адрес регистрации, фактического проживания); гражданство; СНИЛС; сведения, указанные в
          списке участников Общества/выписке из реестра акционеров, аффилированность/взаимозависимость, основание (основания),
          в силу которого лицо признается аффилированным.
          {' '}
          <br />
          5.1.12. для достижения цели, указанной в п.4.3.4. Политики:
          {' '}
          <br />
          Субъекты:
          {' '}
          <br />
          - представители истца/ответчика, представители судебных органов, контролирующих, надзорных органов, органов
          исполнительной власти и местного самоуправления, должностных лиц.
          {' '}
          <br />
          Категории и перечень персональных данных:
          {' '}
          <br />
          - фамилия, имя, отчество, адрес электронной почты, номер телефона, сведения о занимаемой должности и месте работы
          (наименование юридического лица истца/ответчика, представителей судебных органов, контролирующих, надзорных органов,
          органов исполнительной власти и местного самоуправления); реквизиты и сведения документа, удостоверяющего личность;
          сведения, указанные в доверенности (при наличии); сведения об образовании; номер расчетного счета и банковской карты
          (банковские реквизиты); сведения о родственниках работника (степень родства).
          {' '}
          <br />
          5.2. Оператор не осуществляет обработку специальных категорий персональных данных, касающихся расовой, национальной
          принадлежности, политических взглядов, религиозных или философских убеждений, интимной жизни и биометрических
          персональных данных.
          {' '}
          <br />
          5.3. Оператор осуществляет обработку специальных персональных данных о состоянии здоровья работников, которые
          относятся к вопросу о возможности выполнения работником трудовой функции (категория годности, инвалидность,
          временная нетрудоспособность) в пределах, определенных трудовым законодательством РФ для указанной цели.
          <br />
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-5"
        >
          6. Порядок обработки персональных данных
        </h3>
        <p>
          6.1. Оператор осуществляет обработку персональных данных следующими способами: сбор, запись, систематизация,
          накопление, хранение, уточнение (обновление, изменение), использование, передача (доступ, предоставление),
          обезличивание, блокирование, удаление, уничтожение.
          {' '}
          <br />
          6.2. Обработка персональных данных субъектов производится неавтоматизированным и автоматизированным путем с
          передачей по информационно-телекоммуникационным путям и без таковой.
          {' '}
          <br />
          6.3. Обработка персональных данных в целях продвижения товаров, работ, услуг на рынке путем осуществления Оператором
          прямых контактов с помощью средств связи допускается только при условии предварительного согласия субъекта
          персональных данных.
          {' '}
          <br />
          6.4. Оператор вправе на основании договора, соответствующего требованиям ФЗ «О персональных данных», поручить
          обработку персональных данных третьему лицу с согласия субъекта персональных данных, если иное не предусмотрено
          законодательством РФ.
          {' '}
          <br />
          Оператор остается ответственным перед субъектом персональных данных при поручении обработки его персональных данных
          третьему лицу, а третье лицо в полной мере отвечает перед Оператором.
          {' '}
          <br />
          6.5. Персональные данные без согласия субъекта персональных данных передаются Оператором исключительно в случаях,
          предусмотренных в ФЗ «О персональных данных».
          <br />
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-6"
        >
          7. Сроки прекращения обработки персональных данных Оператором.
        </h3>
        <p>
          7.1. Оператор обязан прекратить обработку персональных данных при наступлении следующих событий:
          {' '}
          <br />
          · достигнуты цели обработки или утрачена необходимость в их достижении;
          {' '}
          <br />
          · получен отзыв согласия субъекта персональных данных на обработку персональных данных – если сохранение
          персональных данных не требуется для цели обработки персональных данных;
          {' '}
          <br />
          · представление субъектом персональных данных или его законным представителем сведений, подтверждающих, что
          персональные данные являются незаконно полученными или не являются необходимыми для заявленной цели обработки;
          {' '}
          <br />
          · выявление неправомерной обработки персональных данных при обращении субъекта персональных данных или его законного
          представителя и невозможности обеспечить правомерную обработку персональных данных;
          {' '}
          <br />
          · требование субъекта персональных данных о прекращении обработки персональных данных, если у Оператора нет иного
          основания обработки персональных данных субъектов;
          {' '}
          <br />
          · истечение срока хранения персональных данных, установленного федеральным законом, договором, стороной которого,
          выгодоприобретателем или поручителем по которому является субъект персональных данных или выход субъекта из
          договора, стороной/поручителем/выгодоприобретателем по которому он являлся;
          {' '}
          <br />
          · прекращение действия поручения обработки данных, на основании которого данные обрабатывались.
          {' '}
          <br />
          7.2. Оператор придерживается сроков прекращения обработки персональных данных, указанных в ст.20 и ст.21 ФЗ «О
          персональных данных»
          <br />
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-7"
        >
          8.&nbsp;Обеспечение безопасности персональных данных
        </h3>
        <p>
          8.1. При обработке персональных данных Оператор применяет правовые, организационные и технические меры по
          обеспечению безопасности персональных данных в соответствии со ст. 18.1. и ст. 19 Федерального закона от 27.07.2006
          №152-ФЗ «О персональных данных».
          {' '}
          <br />
          8.2. Обеспечение безопасности персональных данных достигается в частности:
          {' '}
          <br />
          · определением угроз безопасности персональных данных при их обработке в информационных системах персональных данных
          и потенциальных нарушителей безопасности персональных данных, обрабатываемых в информационных системах персональных
          данных;
          {' '}
          <br />
          · определением требуемых уровней защищенности персональных данных, обрабатываемых в информационной системе
          персональных данных и соблюдением требований к защите персональных данных, исполнение которых обеспечивает
          установленные Правительством РФ уровни защищенности персональных данных;
          {' '}
          <br />
          · применением прошедших в установленном порядке процедуру оценки соответствия средств защиты информации;
          {' '}
          <br />
          · оценкой эффективности принимаемых мер по обеспечению безопасности персональных данных до ввода в эксплуатацию
          информационной системы персональных данных;
          {' '}
          <br />
          · учетом машинных носителей персональных данных;
          {' '}
          <br />
          · разграничением прав доступа работников к базе персональных данных информационной системы персональных данных;
          {' '}
          <br />
          · охраной помещений Оператора, ограниченным доступом в помещения, где расположены базы персональных данных;
          {' '}
          <br />
          · обнаружением фактов несанкционированного доступа к персональным данным и принятием мер по исключению в дальнейшем
          такого доступа;
          {' '}
          <br />
          · восстановлением персональных данных, модифицированных или уничтоженных вследствие несанкционированного доступа к
          ним;
          {' '}
          <br />
          · установлением права доступа к персональным данным, обрабатываемым в информационной системе персональных данных, а
          также обеспечением регистрации и учета действий, совершаемых с персональными данными в информационной системе
          персональных данных;
          {' '}
          <br />
          · контролем за принимаемыми мерами по обеспечению безопасности персональных данных и уровнем защищенности системы
          персональных данных.
          {' '}
          <br />
          · назначением лица, ответственного за организацию обработки персональных данных у Оператора.
          {' '}
          <br />
          8.3. Взаимодействие с федеральными органами исполнительной власти по вопросам обработки и защиты персональных данных
          субъектов, персональные данные которых обрабатываются Оператором, осуществляется в соответствии с законодательством
          Российской Федерации.
          <br />
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-8"
        >
          9. Обеспечение прав субъекта персональных данных Оператором
        </h3>
        <p>
          9.1. Субъекты персональных данных обладают правами, предусмотренными ФЗ «О персональных данных» и другими
          нормативно-правовыми актами в сфере обработки персональных данных, а Оператор обеспечивает права субъектов
          персональных данных в порядке, предусмотренном главами 3 и 4 ФЗ «О персональных данных».
          {' '}
          <br />
          9.2.Субъект персональных данных имеет право:
          {' '}
          <br />
          9.2.1. на доступ к своим персональным данным, который включает в себя:
          {' '}
          <br />
          · право на получение информации, касающейся обработки его персональных данных, в объеме, предусмотренном ч.7. ст.14
          ФЗ «О персональных данных»;
          {' '}
          <br />
          · право на уточнение и актуализацию персональных данных;
          {' '}
          <br />
          · право требовать блокирования или уничтожения данных, обрабатываемых с нарушением принципов или оснований
          обработки, указанных в разделах 2 и 3 Политики соответственно;
          {' '}
          <br />
          · право отозвать согласие на обработку своих персональных данных.
          {' '}
          <br />
          Право субъекта персональных данных на доступ к его персональным данным предоставляется Оператором на основании
          обращения или запроса в порядке, предусмотренном ст. 14 ФЗ «О персональных данных», направленного на юридический
          адрес Оператора или по электронной почте
          {' '}
          <a
            className="text-blue-500 hover:text-blue-600"
            href="mailto:info@a2soft.ru"
          >
            <span>info@a2soft.ru</span>
          </a>
          .
          {' '}
          <br />
          Право на доступ к персональным данным может быть ограничено в соответствии с ч.8. ст.14 ФЗ «О персональных данных» и
          другими федеральными законами, в том числе, если доступ субъекта персональных данных к его персональным данным
          нарушает права и законные интересы третьих лиц.
          {' '}
          <br />
          9.2.2. обжаловать действия или бездействия Оператора в уполномоченный орган по защите прав субъектов персональных
          данных или в судебном порядке, если субъект персональных данных считает, что Оператор осуществляет обработку его
          персональных данных с нарушением требований ФЗ «О персональных данных» или иными образом нарушает его права и
          свободы.
          {' '}
          <br />
          9.2.3. защищать свои права и законные интересы, в том числе на возмещение убытков и (или) компенсацию морального
          вреда, в судебном порядке.
          {' '}
          <br />
          9.3. Обязанности Оператора:
          {' '}
          <br />
          9.3.1. обеспечить право на доступ субъекта персональных данных:
          {' '}
          <br />
          9.3.1.1. предоставляя субъекту требуемую информацию по его запросу или обращению; основаниями для отказа в
          предоставлении информации являются:
          {' '}
          <br />
          - поступление повторного запроса, не соответствующего условиям, указанным в ч. 4 и 5 ст.14 ФЗ «О персональных
          данных»,
          {' '}
          <br />
          - наличие обстоятельств, указанных в ч. 8 ст.14 ФЗ «О персональных данных», при этом отказ должен быть мотивирован
          Оператором;
          {' '}
          <br />
          9.3.1.2. уточняя неполные, неактуальные устаревшие данные, блокируя их на период проверки, если это не нарушает
          права и законные интересы субъекта;
          {' '}
          <br />
          9.3.1.3. при выявлении неправомерно обрабатываемых персональных данных — осуществляя блокирование на период
          проверки, а затем, если обеспечить правомерность не представляется возможным, - осуществляя уничтожение таких
          персональных данных;
          {' '}
          <br />
          9.3.1.4. уничтожая незаконно полученные или несоответствующие заявленным целям обработки персональные данные;
          {' '}
          <br />
          9.3.1.5. прекращая обработку персональных данных при достижении заявленных целей обработки, и уничтожая их;
          {' '}
          <br />
          9.3.1.6. осуществляя иные предусмотренные законодательством РФ действия.
          {' '}
          <br />
          9.3.2. уведомить субъекта персональных данных о выполнении своих обязанностей, указанных в п.9.3.1 Политики;
          {' '}
          <br />
          Сроки, указанные выполнения обязанностей, указанных в п.9.3.1. и 9.3.2. Политики определяются ФЗ «О персональных
          данных» или соглашением с субъектом персональных данных.
          {' '}
          <br />
          9.3.3. при отказе субъекта в предоставлении персональных данных разъяснить субъекту персональных данных юридические
          последствия такого отказа, если предоставление персональных данных является обязательным в соответствии с
          законодательством РФ;
          {' '}
          <br />
          9.3.4. если персональные данные получены не от субъекта персональных данных, по основаниям, отличным от согласия на
          обработку персональных данных, до начала обработки персональных данных предоставить субъекту персональных данных
          следующую информацию:
          {' '}
          <br />
          · наименование либо фамилия, имя, отчество и адрес Оператора или его представителя;
          {' '}
          <br />
          · цель обработки персональных данных и ее правовое основание;
          {' '}
          <br />
          · перечень обработки персональных данных;
          {' '}
          <br />
          · о предполагаемых пользователях персональных данных;
          {' '}
          <br />
          · об установленных ФЗ «О персональных данных» правах субъекта персональных данных;
          {' '}
          <br />
          · источник получения персональных данных.
          {' '}
          <br />
          9.3.4.1. Оператор освобождается от обязанности предоставить субъекту персональных данных сведения, предусмотренные
          п.9.3.4. Политики, в случаях, если:
          {' '}
          <br />
          · субъект персональных данных уведомлен об осуществлении обработки его персональных данных соответствующим
          оператором;
          {' '}
          <br />
          · персональные данные получены Оператором на основании федерального закона или в связи с исполнением договора,
          стороной которого, либо выгодоприобретателем или поручителем, по которому является субъект персональных данных;
          {' '}
          <br />
          · Оператор осуществляет обработку персональных данных для статистических или иных исследовательских целей, для
          осуществления профессиональной деятельности журналиста либо научной, литературной или иной творческой деятельности,
          если при этом не нарушаются права и законные интересы субъекта персональных данных;
          {' '}
          <br />
          · предоставление субъекту персональных данных сведений, предусмотренных п.9.3.4. Политики, нарушает права и законные
          интересы третьих лиц;
          {' '}
          <br />
          · иных случаях, предусмотренных законодательством&nbsp;Российской Федерации.
          {' '}
          <br />
          9.3.5. назначить лицо, ответственное за организацию обработки персональных данных, которое обязано:
          {' '}
          <br />
          · осуществлять внутренний контроль за соблюдением Оператором и его работниками законодательства Российской Федерации
          о персональных данных, в том числе требований к защите персональных данных;
          {' '}
          <br />
          · доводить до сведения работников Оператора положения законодательства Российской Федерации о персональных данных,
          локальных актов по вопросам обработки персональных данных, требований к защите персональных данных;
          {' '}
          <br />
          · организовывать прием и обработку обращений и запросов субъектов персональных данных или их представителей, и (или)
          осуществлять контроль за приемом и обработкой таких обращений и запросов.
          {' '}
          <br />
          Указанное лицо получает указания непосредственно от Генерального директора и подотчетно ему.
          {' '}
          <br />
          9.3.6. принимать локальные нормативные акты, определяющие в отношении целей обработки персональных данных, отдельные
          категории субъектов персональных данных, категории и перечень обрабатываемых персональных данных, способы, сроки их
          обработки и хранения, порядок уничтожения персональных данных при достижении цели их обработки или при наступлении
          иных законных оснований, а также локальные нормативно-правовые акты, устанавливающие процедуры, направленные на
          предотвращение и выявление нарушений законодательства Российской Федерации и устранения последствий таких нарушений;
          {' '}
          <br />
          9.3.7. осуществлять внутренний контроль и (или) аудит соответствия обработки персональных данных законодательству
          Российской Федерации, Политике, локальным актам Оператора;
          {' '}
          <br />
          9.3.8. производить оценку вреда, который может быть причинен субъектам персональных данных в случае нарушения
          законодательства Российской Федерации, соотношение указанного вреда и принимаемых Оператором мер, направленных на
          обеспечение выполнения обязанностей, предусмотренных законодательством Российской Федерации;
          {' '}
          <br />
          9.3.9. производить ознакомление работников Оператора, непосредственно осуществляющих обработку персональных данных,
          с положениями законодательства Российской Федерации о персональных данных, в том числе с требованиями к защите
          персональных данных, с документами, определяющими политику Оператора в отношении обработки персональных данных, и
          локальными актами по вопросам обработки персональных данных, или обучения, указанных работников;
          {' '}
          <br />
          9.3.10. при привлечении третьих лиц к обработке персональных данных субъектов — получить согласие субъекта
          персональных данных;
          {' '}
          <br />
          9.3.11. поддерживать актуальность сведений уведомления, направленного уполномоченному органу по защите прав
          субъектов персональных данных, в случаях предусмотренных ст.22 ФЗ «О персональных данных».
          <br />
        </p>
      </div>
      <div className="flex flex-col gap-8">
        <h3
          className="text-2xl font-semibold"
          id="anchor-9"
        >
          10.&nbsp;Ответственность за нарушение норм, регулирующих обработку и защиту персональных данных
        </h3>
        <p>
          10.1. Лица, виновные в нарушении порядка обработки персональных данных, несут дисциплинарную, административную,
          гражданско-правовую или уголовную ответственность в соответствии с законодательством Российской Федерации.
          {' '}
          <br />
          10.2. Руководители структурных подразделений Оператора несут персональную ответственность за исполнение обязанностей
          их подчиненными.
        </p>
      </div>
    </div>
  );
}
